var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFacilityMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#004C4C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8182 8.30233C10.8182 7.58307 11.388 7 12.0909 7H16.2273C16.9302 7 17.5 7.58307 17.5 8.30233V9.60465H17.8182C18.5211 9.60465 19.0909 10.1877 19.0909 10.907V19.6977H20.3636C20.7151 19.6977 21 19.9892 21 20.3488C21 20.7085 20.7151 21 20.3636 21H7.63636C7.28491 21 7 20.7085 7 20.3488C7 19.9892 7.28491 19.6977 7.63636 19.6977H8.90909V11.5581C8.90909 10.4793 9.76382 9.60465 10.8182 9.60465V8.30233ZM12.0909 9.60465H14.9545C15.306 9.60465 15.5909 9.89619 15.5909 10.2558C15.5909 10.6154 15.306 10.907 14.9545 10.907H10.8182C10.4667 10.907 10.1818 11.1985 10.1818 11.5581V19.6977H17.8182V10.907H17.5C16.7971 10.907 16.2273 10.3239 16.2273 9.60465V8.30233H12.0909V9.60465ZM11.1364 14.1628C11.1364 13.8032 11.4213 13.5116 11.7727 13.5116H12.4091C12.7606 13.5116 13.0455 13.8032 13.0455 14.1628C13.0455 14.5224 12.7606 14.814 12.4091 14.814H11.7727C11.4213 14.814 11.1364 14.5224 11.1364 14.1628ZM14.9545 14.1628C14.9545 13.8032 15.2394 13.5116 15.5909 13.5116H16.2273C16.5787 13.5116 16.8636 13.8032 16.8636 14.1628C16.8636 14.5224 16.5787 14.814 16.2273 14.814H15.5909C15.2394 14.814 14.9545 14.5224 14.9545 14.1628ZM11.1364 17.093C11.1364 16.7334 11.4213 16.4419 11.7727 16.4419H12.4091C12.7606 16.4419 13.0455 16.7334 13.0455 17.093C13.0455 17.4527 12.7606 17.7442 12.4091 17.7442H11.7727C11.4213 17.7442 11.1364 17.4527 11.1364 17.093ZM14.9545 17.093C14.9545 16.7334 15.2394 16.4419 15.5909 16.4419H16.2273C16.5787 16.4419 16.8636 16.7334 16.8636 17.093C16.8636 17.4527 16.5787 17.7442 16.2273 17.7442H15.5909C15.2394 17.7442 14.9545 17.4527 14.9545 17.093Z",
    fill: "#004C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacilityMap);
export default __webpack_public_path__ + "static/media/ic_facility-map.64bc5b3b8a76560d79eea04de5ef2c84.svg";
export { ForwardRef as ReactComponent };